// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d4053ba6","264":"08c64869","796":"0452e70a","953":"baee02e5","992":"7a65f12b"}[chunkId] + ".chunk.js";
};